import(/* webpackMode: "eager" */ "/var/www/716-cannabis/app/shop/product/[slug]/page.tsx");
